export default __webpack_public_path__ + "static/media/icw-powered-by-logo.a86e7db5.svg";